import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule, IonNav } from '@ionic/angular';

import { MyOrdersViewPageRoutingModule } from './my-orders-view-routing.module';

import { MyOrdersViewPage } from './my-orders-view.page';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MyOrdersTracingEffects } from '../../tracking/tracing/my-orders-tracing.effects';
import { EffectsModule } from '@ngrx/effects';
import { MyOrdersListViewComponent } from '@order/components/orders-list/my-orders-view/desktop/my-orders-list-view/my-orders-list-view.component';
import { MyOrdersListViewTabletComponent } from '@order/components/orders-list/my-orders-view/tablet/my-orders-list-view-tablet/my-orders-list-view-tablet.component';
import { MyOrdersListViewMobileComponent } from '@order/components/orders-list/my-orders-view/mobile/my-orders-list-view-mobile/my-orders-list-view-mobile.component';
import { CopyOrderModalDesktopComponent } from '@app/my-orders/copy-order-modal/copy-order-modal-desktop/copy-order-modal-desktop.component';
import { CopyOrderModalTouchComponent } from '@app/my-orders/copy-order-modal/copy-order-modal-touch/copy-order-modal-touch.component';
import { OrderCardActionsBarModule } from '@order/components/orders-list/order-card-actions-bar/order-card-actions-bar.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MyOrdersViewPageRoutingModule,
    SharedModule,
    TranslateModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatCardModule,
    EffectsModule.forFeature([MyOrdersTracingEffects]),
    OrderCardActionsBarModule,
  ],
  declarations: [
    MyOrdersViewPage,
    MyOrdersListViewComponent,
    MyOrdersListViewTabletComponent,
    MyOrdersListViewMobileComponent,
    CopyOrderModalDesktopComponent,
    CopyOrderModalTouchComponent,
  ],
  providers: [IonNav],
})
export class MyOrdersViewPageModule {}
